// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tvKTldbEjl4nFDukj8Oo {
    flex: 1;
    position: relative;
    padding: 16px;
}

@media (width >= 768px) {
    .tvKTldbEjl4nFDukj8Oo {
        flex: 0 0 270px;
        padding-bottom: 0;
    }
}

@media (width <= 767px) {
    .tvKTldbEjl4nFDukj8Oo {
        width: 100%;
    }
}

.WqSINIh5d1K6Zvgf7len {
    text-align: center;
    opacity: 0.5;
    padding: 20px 0;
}

.pjO3emWKLe72Imrz33ZD {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
    margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Summary/Summary.module.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".wrapper {\n    flex: 1;\n    position: relative;\n    padding: 16px;\n}\n\n@media (width >= 768px) {\n    .wrapper {\n        flex: 0 0 270px;\n        padding-bottom: 0;\n    }\n}\n\n@media (width <= 767px) {\n    .wrapper {\n        width: 100%;\n    }\n}\n\n.titlePlaceholder {\n    text-align: center;\n    opacity: 0.5;\n    padding: 20px 0;\n}\n\n.cancelButton {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 16px;\n    margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `tvKTldbEjl4nFDukj8Oo`,
	"titlePlaceholder": `WqSINIh5d1K6Zvgf7len`,
	"cancelButton": `pjO3emWKLe72Imrz33ZD`
};
export default ___CSS_LOADER_EXPORT___;
